// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__dmqec","sidebarContent":"SideBar_sidebarContent__22QZO","flex":"SideBar_flex__23mW1","active":"SideBar_active__UmlcP"};